import { CatalogBlock } from "./CatalogBlock";
import { getActiveCatalogFilters, getCatalogParams } from "./catalogParams";

export type CatalogPageProps = {
  /**
   * Path already in the BFF's vocabulary (`/s/…`, `/c/…`, `/b/…`), built by the
   * route out of its own prefix. It used to be derived from the slug in here,
   * which only worked while the prefix travelled inside the slug via a rewrite.
   */
  path: string;
  searchParams: Promise<{ [key: string]: string | string[] | undefined }>;
};

export async function CatalogPage({
  path,
  searchParams,
}: Readonly<CatalogPageProps>) {
  const resolvedSearchParams = await searchParams;
  const catalogParams = getCatalogParams(resolvedSearchParams);
  const activeFilters = getActiveCatalogFilters(resolvedSearchParams);

  return (
    <CatalogBlock
      path={path}
      page={catalogParams.page}
      sort={catalogParams.sort}
      filters={activeFilters}
      withInit
      withBreadcrumb
      withCmsContent
    />
  );
}
